(function () {
  function attachSearchInfiniteScroll(container) {
    if (!container) return;
    if (container.getAttribute('data-search-infinite-scroll-init') === 'true') return;

   var grid = container.querySelector('#product-grid ul.grid.product-grid');
    var sentinel = container.querySelector('[data-infinite-scroll-sentinel]');
    var status = container.querySelector('[data-infinite-scroll-status]');

    if (!grid || !sentinel) return;

    container.setAttribute('data-search-infinite-scroll-init', 'true');

    function getNextUrl() {
      return container.getAttribute('data-next-page') || '';
    }

    function normalizeNextUrl(value) {
      if (!value) return '';

      var trimmed = String(value).trim();

      if (/^\d+$/.test(trimmed)) {
        var url = new URL(window.location.href);
        url.searchParams.set('page', trimmed);
        return url.toString();
      }

      if (trimmed.charAt(0) === '/') {
        return window.location.origin + trimmed;
      }

      return trimmed;
    }

    function setNextUrl(url) {
      container.setAttribute('data-next-page', url || '');
    }

    function isLoading() {
      return container.getAttribute('data-loading') === 'true';
    }

    function setLoading(value) {
      container.setAttribute('data-loading', value ? 'true' : 'false');
      container.classList.toggle('is-loading', !!value);
    }

    function cleanupDynamicItem(item) {
      item.classList.remove('scroll-trigger', 'animate--slide-in');
      item.removeAttribute('data-cascade');
      item.style.removeProperty('--animation-order');

      item.querySelectorAll('.scroll-trigger, .animate--slide-in').forEach(function (el) {
        el.classList.remove('scroll-trigger', 'animate--slide-in');
        el.removeAttribute('data-cascade');
        el.style.removeProperty('--animation-order');
      });
    }

    async function loadNextPage() {
      var nextUrl = normalizeNextUrl(getNextUrl());

      if (!nextUrl || isLoading()) return;

      setLoading(true);

      if (status) {
        status.textContent = 'Loading more products';
      }

      try {
        var response = await fetch(nextUrl, {
          credentials: 'same-origin',
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        });

        if (!response.ok) {
          throw new Error('Failed to load next search page');
        }

        var html = await response.text();
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        var newContainer = doc.querySelector('#ProductGridContainer[data-search-infinite-scroll]');
        var newGrid = newContainer
          ? newContainer.querySelector('#product-grid ul.grid.product-grid')
          : null;

        if (!newGrid) {
          setNextUrl('');
          disconnectAll();
          return;
        }

        var items = newGrid.querySelectorAll(':scope > li.grid__item');

        if (!items.length) {
          setNextUrl('');
          disconnectAll();
          return;
        }

        var fragment = document.createDocumentFragment();

        items.forEach(function (item) {
          cleanupDynamicItem(item);
          fragment.appendChild(item);
        });

        grid.appendChild(fragment);

        var newNextUrl = newContainer.getAttribute('data-next-page') || '';
        setNextUrl(newNextUrl);

        if (status) {
          status.textContent = newNextUrl ? 'Loaded more products' : 'No more products';
        }

        if (!newNextUrl) {
          disconnectAll();
        }
      } catch (error) {
        console.error('Search infinite scroll error:', error);

        if (status) {
          status.textContent = 'Unable to load more products';
        }
      } finally {
        setLoading(false);
      }
    }

    function nearBottom() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      var sentinelTop = sentinel.getBoundingClientRect().top + scrollTop;

      return scrollTop + viewportHeight >= sentinelTop - 900;
    }

    var scrollTicking = false;

    function onScroll() {
      if (scrollTicking) return;

      scrollTicking = true;

      window.requestAnimationFrame(function () {
        if (nearBottom()) {
          loadNextPage();
        }

        scrollTicking = false;
      });
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            loadNextPage();
          }
        });
      },
      {
        root: null,
        rootMargin: '900px 0px',
        threshold: 0
      }
    );

    function disconnectAll() {
      observer.disconnect();
      window.removeEventListener('scroll', onScroll);
    }

    observer.observe(sentinel);
    window.addEventListener('scroll', onScroll, { passive: true });

    if (nearBottom()) {
      loadNextPage();
    }
  }

  function initSearchInfiniteScroll() {
    document.querySelectorAll('[data-search-infinite-scroll]').forEach(function (container) {
      attachSearchInfiniteScroll(container);
    });
  }

  document.addEventListener('DOMContentLoaded', initSearchInfiniteScroll);
  document.addEventListener('shopify:section:load', initSearchInfiniteScroll);
})();